import {all} from 'redux-saga/effects';
import {createFetchSagaLatest} from 'utils/sagas';

import {fetchCountries as fetchCountriesAction} from './';

import {fetchCountries} from 'sdk/countries';

function* countriesSaga() {
  yield all([createFetchSagaLatest(fetchCountriesAction, fetchCountries)]);
}

export default countriesSaga;
